import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoaders } from 'selectors';
import { linkWithParams } from 'routes';
import { updateAccounts } from 'actions/partner';
import AccountsTable from 'components/accounts/AccountsTable';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getLoaders(state, ['DASHBOARD_FILTER', 'ACCOUNTS']),
    meta: state.meta.accounts,
    accounts: state.accounts,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAccount: (id) => {
      const path = {pathname: linkWithParams('account', {id})};
      dispatch(push(path));
    },
    onPageChange: (page) => {
      dispatch(updateAccounts({page}))
    },
    onSortChange: (sort, order) => {
      dispatch(updateAccounts({sort, order}))
    },
  }
}

const AccountsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountsTable)

export default AccountsContainer;
